import moment from 'moment-timezone';
import i18n from '@/js/i18n';

// eslint-disable-next-line import/prefer-default-export
export function getStatutDesactivation(item, isMobile) {
  const statut = {};
  statut.indDesactive = false;
  if (
    (item && item.indDesactivationInternet === 'true' && !isMobile) ||
    (item && item.indDesactivationMobile === 'true' && isMobile)
  ) {
    const maintenant = moment();
    const debut = item.dateDesactivationDebut
      ? moment(item.dateDesactivationDebut).tz('America/Montreal', true)
      : null;
    const fin = item.dateDesactivationFin
      ? moment(item.dateDesactivationFin).tz('America/Montreal', true)
      : null;
    if (
      ((!debut || maintenant.isAfter(debut)) && (!fin || maintenant.isBefore(fin))) ||
      (!debut && !fin)
    ) {
      statut.indDesactive = true;
      statut.message =
        item.txtDesactivation ??
        i18n.t('casino.desactivation.desactivationEnCours') +
          (fin
            ? fin.local().format(i18n.t('casino.desactivation.formatHeure'))
            : i18n.t('casino.desactivation.desactivationMomentIndetermine'));
      return statut;
    }
    if (maintenant.isBefore(debut) && maintenant.isSame(debut, 'd')) {
      statut.indDesactive = false;
      statut.message =
        item.txtDesactivation ??
        i18n.t('casino.desactivation.desactivationAVenir') +
          debut.local().format(i18n.t('casino.desactivation.formatHeure')) +
          i18n.t('casino.desactivation.desactivationAVenir2');
      return statut;
    }
    statut.message = null;
  }
  return statut;
}

export function checkInferieurNbJourLimite(dateProduitLancement, nbJourLimite) {
  const dateActuelle = moment().tz('America/Montreal', true).startOf('day');
  const dateLancement = moment(dateProduitLancement).tz('America/Montreal', true);

  /* Le calcul de la date était imprécise en raison du calcul par nombre de jour
    exemple nous somme le 20 juin 15:00 et je veux les jeux qui sont sorti il y a 1 jour
    donc normalement on voudrait les jeux qui sont sorti à partir de 19 juin 00:00:00
    La date du jour actuel ne prend pas en charge l'heure donc la date du jour serait 20 juin 00:00:00
    Si le client inscrivait la date de lancement il y a 2 jours (18 juin 03:00) il serait sorti dans les résultats alors qu'il aurait pas du être affiché 
    car le nombre de jour de différence serait plus petit que 2
    En utilisant les seconde nous pouvons donc valider que le jeu date bien de 1 jour et non 1.9 jours
  */

  // return dateActuelle.diff(dateLancement, 'days') <= nbJourLimite;
  return dateActuelle.diff(dateLancement, 'seconds') <= nbJourLimite * 86400; // 86400 secondes = 1 jour
}
